import React from "react";
import { ShoppingBag } from "lucide-react";
import { useStore } from "@/store/StoreContext";

export default function StickyCTA() {
  const { cartCount, setCartOpen } = useStore();
  return (
    <button
      data-testid="sticky-shop-cta"
      onClick={() => setCartOpen(true)}
      className="fixed bottom-5 left-1/2 z-40 flex -translate-x-1/2 items-center gap-2.5 rounded-full border border-[#D4AF37]/60 bg-[#1C130B]/95 py-3 pl-5 pr-6 text-[11px] font-bold uppercase tracking-[0.18em] text-[#F3E5AB] shadow-[0_16px_50px_-10px_rgba(28,19,11,0.5)] backdrop-blur-xl transition-colors duration-300 hover:bg-[#D4AF37] hover:text-[#1C130B] md:hidden"
    >
      <ShoppingBag className="h-4 w-4" />
      {cartCount > 0 ? `Cart · ${cartCount} item${cartCount > 1 ? "s" : ""}` : "Shop Diwali Collection"}
    </button>
  );
}
